import React, { useEffect, useState } from "react";

const STORAGE_KEY = "helixora_research_verified_v1";

export const AgeGate = () => {
    const [state, setState] = useState(null); // null | "prompt" | "accepted" | "denied"

    useEffect(() => {
        const v = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
        if (v === "accepted") setState("accepted");
        else if (v === "denied") setState("denied");
        else setState("prompt");
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, "accepted");
        setState("accepted");
    };
    const deny = () => {
        localStorage.setItem(STORAGE_KEY, "denied");
        setState("denied");
    };

    if (state === null || state === "accepted") return null;

    if (state === "denied") {
        return (
            <div className="fixed inset-0 z-[9999] bg-ink-base flex items-center justify-center px-6" data-testid="age-gate-denied">
                <div className="max-w-lg w-full border border-red-900/60 bg-ink-surface p-10 text-center">
                    <div className="overline text-red-400 mb-3">ACCESS RESTRICTED</div>
                    <h1 className="font-display text-3xl sm:text-4xl font-bold text-ink leading-[1.05]">
                        Sorry — you cannot access this site.
                    </h1>
                    <p className="mt-6 text-sm text-ink-dim leading-relaxed">
                        Entry to Helixora Peptides requires that you be at least <strong className="text-ink">21 years of age</strong> and confirm that all purchases are for lawful scientific, laboratory, analytical, in-vitro, or ex-vivo research.
                    </p>
                    <p className="mt-4 text-xs text-ink-mute">Our products are research chemicals only — not drugs, foods, cosmetics, dietary supplements, or medical products.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 z-[9999] bg-ink-base/95 backdrop-blur-sm flex items-center justify-center px-4 sm:px-6 overflow-y-auto py-8" data-testid="age-gate">
            <div className="max-w-2xl w-full border border-ink-strong bg-ink-surface relative my-auto">
                <div className="h-1 bg-gradient-to-r from-neon via-gold to-neon" />
                <div className="p-6 sm:p-10">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="h-px w-10 bg-neon" />
                        <p className="overline text-neon text-[10px]">HELIXORA.PEPTIDES · ENTRY PROTOCOL</p>
                    </div>
                    <h1 className="font-display text-2xl sm:text-4xl font-bold text-ink leading-[1.05] tracking-tight">
                        Please read and acknowledge<br />
                        <span className="text-neon">to proceed to site.</span>
                    </h1>

                    <div className="mt-7 space-y-4 text-sm text-ink-dim leading-relaxed max-h-[45vh] overflow-y-auto pr-2">
                        <p>
                            Entry and purchase require confirmation that you are at least <strong className="text-ink">21 years of age</strong> and are acquiring materials solely for lawful scientific, laboratory, analytical, in-vitro, or ex-vivo research. All items are supplied strictly as research chemicals. They are <strong className="text-ink">not drugs, foods, cosmetics, dietary supplements, or medical products.</strong>
                        </p>
                        <p>
                            No product is intended for human or animal consumption, administration, diagnostic use, therapeutic use, clinical use, or manufacturing of any kind. No medical guidance, dosing information, or in-vivo application advice is provided. All researcher qualifications are self-attested.
                        </p>
                        <p>
                            All lyophilized products require reconstitution only for laboratory research. No ancillary supplies are included. Purchases are subject to all applicable laws and regulations.
                        </p>
                        <p>
                            Misuse, diversion, or misrepresentation voids any rights or protections. Handling, storage, and lawful use are solely your responsibility.
                        </p>
                        <div className="pt-3 border-t border-ink">
                            <p className="overline text-gold text-[10px] mb-2">FDA DISCLAIMER</p>
                            <p className="text-xs">Products have not been evaluated by the FDA and are not intended to diagnose, treat, cure, or prevent any disease. Not for human or veterinary use.</p>
                        </div>
                    </div>

                    <div className="mt-8 flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={accept}
                            className="flex-1 bg-neon hover:bg-neon-glow text-black px-6 py-4 font-bold tracking-wide transition-colors"
                            data-testid="age-gate-agree"
                        >
                            I AGREE · 21+ · ENTER SITE
                        </button>
                        <button
                            onClick={deny}
                            className="sm:flex-none border border-ink-strong hover:border-red-900/60 text-ink-dim hover:text-red-400 px-6 py-4 font-bold tracking-wide transition-colors text-sm"
                            data-testid="age-gate-disagree"
                        >
                            DISAGREE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
